jQuery(document).ready(function ($) {

    ;( function () {

        const $site_navbar = $('.site-navbar');
        const $gallery = $('.gallery');

        if( !$gallery.length )
            return;

        const gallery_animation = () => {
            let animation = false;
            const _animation_init = () => {
                if( animation ) return;
                const items = $('figure.gallery__grid-item > a');
                let i = 0;
                items.each( function () {
                    const $this = $(this);
                    setTimeout(function(){
                        $this.addClass('-pre-gallery-animation');
                        $this.css({
                            'visibility': 'visible',
                            'opacity': '1'
                        })
                    }, 500 + i);
                    i += 200
                });
                animation = true;
            };

            if ( ( jQuery(window).scrollTop() + window.innerHeight )  >= $gallery.offset().top && !animation ){
                _animation_init();
            }
        };

        ( function () {
            gallery_animation();
            $(window).on('scroll', gallery_animation );
        })();

        const selector = `.gallery__grid-item--ref`;
        $gallery.lightGallery({
            selector, // Custom selector property instead of just child. pass this to select same element ex : .class #id
            pager: false, // Enable/Disable pager
            zoom: false, // Enable/Disable zoom option
            autoplayControls: false, // Show/hide autoplay controls.
            download: false, // Enable download button. By default download url will be taken from data-src/href attribute but it supports only for modern browsers. If you want you can provide another url for download via data-download-url. Pass false in data-download-url if you want to hide download button for the particular slide.
            thumbnail:false,
            animateThumb: false,
            showThumbByDefault: false
        });
        /**
         * Note: true - If you pass true as a parameter destroy method will destroy the gallery completely.
         *      If parameter is undefined or false destroy will only close the gallery and plugins instance remains with the element.
         */
        $('body').on('click touchstart', '.lg-close', () => $gallery.data('lightGallery').destroy(false) );

    })();

});